/**
 * The General page's thread-notification rows of the settings-search catalog,
 * extracted from `settingsSearch.ts` so that file stays within its size
 * ratchet. Same shape, same rules: the catalog stays the single source of the
 * rendered titles.
 *
 * @module
 */

export const NOTIFICATION_SETTINGS_SEARCH_ROWS = [
  {
    id: "general-notifications",
    title: "Thread notifications",
    to: "/settings/general",
    keywords: ["notifications", "sound", "alerts", "permission", "desktop", "badge"],
  },
  {
    id: "general-in-app-notifications",
    title: "In-app notifications",
    to: "/settings/general",
    keywords: ["toast", "banner", "in app"],
  },
] as const;
